import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "fileType-word",
  "use": "fileType-word-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"fileType-word\"><defs><symbol id=\"fileType-word_file-word\" data-name=\"file-word\" viewBox=\"0 0 20 20\"><path d=\"M15.77,0H0V20H20V4.23Zm-3.5,13.57h-1.1L9.8,8.35h0L8.39,13.57H7.28L5.34,6.81H6.5l1.32,5.27h0L9.24,6.81h1.08l1.38,5.27h0l1.32-5.27h1.17Zm3.5-9.2V.28l4.08,4.08Z\" fill=\"#4471bc\" /></symbol></defs><title>fileType-word</title><g id=\"fileType-word_图层_2\" data-name=\"图层 2\"><g id=\"fileType-word_图层_1-2\" data-name=\"图层 1\"><use width=\"20\" height=\"20\" xlink:href=\"#fileType-word_file-word\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/fileType-word.svg
// module id = nlge
// module chunks = 264